module.exports = __webpack_public_path__ + "assets/img/A1.7ef2b3ca.png";